/** @jsxImportSource @emotion/react */
import React from 'react'
import { NotificationForm, NotificationPreview } from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/NotificationContext'
import { breadcrumbItems } from '../../utils'
import { Breadcrumb } from '../../../components/atoms'

const { index, contentManagement, manageNotifications } = breadcrumbItems

const ManageNews: React.FC = () => {
  return (
    <Provider>
      <Breadcrumb items={[index, contentManagement, manageNotifications]} />
      <div css={styles.root}>
        <div css={styles.main}>
          <NotificationForm />
        </div>
        <div css={styles.right}>
          <NotificationPreview />
        </div>
      </div>
    </Provider>
  )
}

export default ManageNews
